export default class AnimationScrollPage {
  constructor() {
    this.$el = $('.animation');
    this.winH = window.innerHeight;
    this.winW = window.innerWidth;
    this.offset = window.innerHeight;
    this.WindowScrollTop = null;
    this.topCurrent = null;
    this.addClassAni = 'set-animation';
  }

  init() {
    this.animationEle();
    $(window).on('scroll resize', () => {
      this.animationEle();
    });
  }

  formatNumber(text, min, max) {
    return text.toLocaleString('en-US', {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    });
  }

  parseNumberText(originalText) {
    const result = {
      numberCount: 0,
      prefix: '',
      suffix: '',
      isRange: false,
      rangeStart: 0,
      rangeEnd: 0,
    };

    if (originalText.includes('-')) {
      result.isRange = true;
      const [start, end] = originalText.split('-');
      result.rangeStart = parseFloat(start);
      const endMatch = end.match(/^(\d+\.?\d*)(.*)$/);
      if (endMatch) {
        result.rangeEnd = parseFloat(endMatch[1]);
        result.suffix = endMatch[2] || '';
      }
      result.numberCount = result.rangeEnd;
    } else {
      const match = originalText.match(/^(\D*)(\d+\.?\d*)(\D*)$/);
      if (match) {
        result.prefix = match[1] || '';
        result.numberCount = parseFloat(match[2]);
        result.suffix = match[3] || '';
      } else {
        result.numberCount = parseFloat(originalText);
      }
    }

    return result;
  }

  calculateAnimationParams(numberCount, isRange, rangeStart, rangeEnd) {
    let incrementRate = 0.015;
    let durationAnima;

    if (isRange) {
      const ratio = rangeStart / rangeEnd;
      incrementRate = 0.02;
      let baseDuration = Math.round(numberCount / incrementRate);
      if ((1 - ratio) * baseDuration > 1000) {
        baseDuration = Math.round(1000 / (1 - ratio));
      }
      durationAnima = Math.max(800, Math.min(3000, baseDuration));
    } else {
      if (numberCount >= 1000000) {
        incrementRate = 0.3;
      } else if (numberCount >= 1000) {
        incrementRate = 0.1;
      } else if (numberCount >= 100) {
        incrementRate = 0.05;
      } else {
        // empty code
      }

      durationAnima = Math.max(1500, Math.min(4000, Math.round(numberCount / incrementRate)));
    }

    return { incrementRate, durationAnima };
  }

  animationNumber($el) {
    const originalText = $el.text().trim();
    const parsed = this.parseNumberText(originalText);

    if (Number.isNaN(parsed.numberCount)) {
      return;
    }

    const initialValue = parsed.isRange ? '0-0' : `${parsed.prefix}0`;
    $el.text(`${initialValue}${parsed.suffix}`);
    $el.addClass('counted');

    const { durationAnima } = this.calculateAnimationParams(
      parsed.numberCount,
      parsed.isRange,
      parsed.rangeStart,
      parsed.rangeEnd,
    );

    setTimeout(() => {
      $el.prop('Counter', 0).animate(
        { Counter: parsed.numberCount },
        {
          duration: durationAnima,
          easing: 'linear',
          step: (now) => {
            if (parsed.isRange) {
              const progress = now / parsed.numberCount;
              const currentStart = progress * 1.5 >= 1 ? parsed.rangeStart : parsed.rangeStart * progress * 1.5;
              $el.text(`${Math.floor(currentStart)}-${this.formatNumber(Math.floor(now), 0, 2)}${parsed.suffix}`);
            } else {
              $el.text(`${parsed.prefix}${this.formatNumber(Math.floor(now), 0, 2)}${parsed.suffix}`);
            }
          },
          complete: () => {
            $el.text(originalText);
          },
        },
      );
    }, 100);
  }

  animationEle() {
    this.offset = this.winH;
    if ($('.wrapper').hasClass('has-animation')) {
      this.WindowScrollTop = $(window).scrollTop();
      this.$el.each((_index, ele) => {
        const $elm = $(ele);
        if ($elm.hasClass(this.addClassAni)) {
          return true;
        }
        this.topCurrent = $elm.offset().top;
        if (this.WindowScrollTop > this.topCurrent - this.offset) {
          $elm.addClass(this.addClassAni);
          if ($elm.find('.clinical-information-item__title')) {
            $elm.find('.clinical-information-item__title').each((_i, e) => {
              this.animationNumber($(e));
            });
          }
          return true;
        }
        return false;
      });
    }
  }
}

new AnimationScrollPage().init();
